var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /Users/yuki/Dropbox/Mac/Desktop/web design/dog-ema-wp/wp-content/themes/ema/node_modules/core-js/modules/_shared-key.js
// module id = 72
// module chunks = 0